'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actions = require('./actions');

var _actions2 = _interopRequireDefault(_actions);

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildAvatarUrl = function buildAvatarUrl(oldUrl) {
  return oldUrl.split('?')[0] + '?' + Date.now();
};

// const cloneWithout = (obj, ...keys) => {
//   const clone = { ...obj };
//   for (key in keys) {
//     delete obj[key];
//   }
//   return obj;
// }

var booted = function booted() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case _actions2.default.BOOTSTRAPPED:
      return true;
    default:
      return state;
  }
};

var auth = function auth() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _actions2.default.BOOTSTRAPPED:
      return action.payload.authedUser || {};
    case _actions2.default.USER_SAVED:
      return _extends({}, state, action.payload);
    case _actions2.default.AVATAR_CHANGED:
      return _extends({}, state, { avatarUrl: buildAvatarUrl(state.avatarUrl) });
    default:
      return state;
  }
};

var user = function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { pending: true };
  var action = arguments[1];

  switch (action.type) {
    case _actions2.default.USER_ASK:
      return _extends({}, action.payload, { pending: true });
    case _actions2.default.USER_LOAD_FAIL:
      return _extends({}, state, { fail: true, pending: false });
    case _actions2.default.USER_LOADED:
      return _extends({}, action.payload, { pending: false });
    case _actions2.default.USER_EDIT:
      return _extends({}, state, { staged: _extends({}, state.staged || {}, action.payload) });
    case _actions2.default.USER_CANCEL:
      return _extends({}, state, { staged: null });
    case _actions2.default.USER_SAVE:
      return _extends({}, state, state.staged, { staged: null });
    case _actions2.default.AVATAR_CHANGED:
      return _extends({}, state, { avatarUrl: buildAvatarUrl(state.avatarUrl) });
    case _actions2.default.FOLLOW:
      return _extends({}, state, { followed: true, followersCount: state.followersCount + 1 });
    case _actions2.default.UNFOLLOW:
      return _extends({}, state, { followed: false, followersCount: state.followersCount - 1 });
    default:
      return state;
  }
};

var inventory = function inventory() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _actions2.default.BOOTSTRAPPED:
      return _extends({}, action.payload.inventory, {
        academyBadges: action.payload.inventory.academyBadges.reduce(function (acc, val) {
          acc[val.id] = val;
          return acc;
        }, [])
      });
    default:
      return state;
  }
};

var reservedRoots = function reservedRoots() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _actions2.default.BOOTSTRAPPED:
      return action.payload.reservedRoots;
    default:
      return state;
  }
};

var lists = function lists() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _actions2.default.TOY_LIST_LOADED:
      return { toy: action.payload };
    default:
      return state;
  }
};

var topUsers = function topUsers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case _actions2.default.BOOTSTRAPPED:
      return action.payload.topUsers;
    default:
      return state;
  }
};

var users = function users() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case _actions2.default.BOOTSTRAPPED:
      return action.payload.topUsers;
    case _actions2.default.USERS_LOADED:
      return action.payload;
    default:
      return state;
  }
};

exports.default = (0, _redux.combineReducers)({
  booted: booted,
  auth: auth,
  user: user,
  inventory: inventory,
  reservedRoots: reservedRoots,
  lists: lists,
  topUsers: topUsers,
  users: users,
  router: _reactRouterRedux.routerReducer
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers.js
// module id = 183
// module chunks = 0